import React, { useState } from 'react';
import { Alert, Box, Button, Divider, Link, Stack, Typography } from '@mui/material';
import { getMobileSignInUrl, isMobileBrowser, openPlayerDexApp } from '../../auth/mobileSignInLink';
import { useTranslation } from '../../context/Internationalization';
import { LOGIN_ROUTE } from '../../routes';
import AuthLayout from './AuthLayout';
import appStoreBadge from '../../assets/images/store-badges/app-store.svg';
import googlePlayBadge from '../../assets/images/store-badges/google-play.svg';

export default function MobileSignInFallback() {
  const { t } = useTranslation();
  const [attempted, setAttempted] = useState(false);
  const mobile = isMobileBrowser();
  const validLink = Boolean(getMobileSignInUrl());

  const openApp = () => {
    setAttempted(true);
    // A deliberate tap avoids automatic redirects and popup/redirect loops.
    // Do not copy the credential into rendered markup or application storage.
    try { openPlayerDexApp(); } catch (_) { /* Browser may block custom schemes. */ }
  };

  return <AuthLayout>
    <Stack spacing={3}>
      <Typography component="h1">{t('mobile_sign_in_title')}</Typography>
      <Typography color="text.secondary">{t('mobile_sign_in_description')}</Typography>
      {!validLink ? <Alert severity="info">{t('mobile_sign_in_invalid')}</Alert> : mobile ? <>
        <Button variant="contained" size="large" onClick={openApp}>{t('mobile_sign_in_open')}</Button>
        {attempted && <Alert severity="info" role="status">{t('mobile_sign_in_open_help')}</Alert>}
      </> : <Alert severity="info">{t('mobile_sign_in_desktop')}</Alert>}
      <Typography variant="body2" color="text.secondary">{t('mobile_sign_in_install_help')}</Typography>
      <Stack direction="row" spacing={2} useFlexGap sx={{ flexWrap: 'wrap' }}>
        <Link href="https://apps.apple.com/gr/app/playerdex-academy/id1584881110" target="_blank" rel="noopener noreferrer" aria-label={t('download_on_app_store')}>
          <Box component="img" src={appStoreBadge} alt="" sx={{ display: 'block', width: 135, height: 40 }} />
        </Link>
        <Link href="https://play.google.com/store/apps/details?id=app.playerdex.onetouchfootball" target="_blank" rel="noopener noreferrer" aria-label={t('get_it_on_google_play')}>
          <Box component="img" src={googlePlayBadge} alt="" sx={{ display: 'block', width: 135, height: 40 }} />
        </Link>
      </Stack>
      <Divider />
      <Typography variant="body2" color="text.secondary">{t('mobile_sign_in_manager_help')}</Typography>
      {/* Full navigation discards the action URL before Manager can bootstrap. */}
      <Button component="a" href={LOGIN_ROUTE} variant="outlined" referrerPolicy="no-referrer">{t('mobile_sign_in_manager')}</Button>
    </Stack>
  </AuthLayout>;
}
